const testimonials = [
  {
    name: "Master Sergeant David H.",
    location: "Barksdale AFB, Bossier City",
    rating: 5,
    text: "Got PCS orders to Ramstein Air Base with 22 days to report. My wife's passport expired and our youngest had never had one. Fast Passport Center walked us through both applications simultaneously, reviewed every document, and had both passports back in seven business days. Made our reporting date with nearly two weeks to spare. This service is invaluable for Barksdale families getting surprise orders.",
    service: "Family Expedited Passports",
  },
  {
    name: "Michelle P.",
    location: "Horseshoe Bossier City",
    rating: 5,
    text: "I was selected to attend an international gaming leadership conference in Singapore and had about three and a half weeks. My passport was expired. Fast Passport Center was incredibly efficient — reviewed everything, kept me updated daily, and I had my passport with a week to spare. I made the conference and represented our property well. Absolutely professional service.",
    service: "Passport Renewal",
  },
  {
    name: "Robert T.",
    location: "Downtown Shreveport",
    rating: 5,
    text: "I commute to Dallas for business and had an international client meeting pop up in Frankfurt with about two weeks notice. My passport had been expired for six months. Fast Passport Center had my renewal processed in five business days. I flew from SHV to Dallas to Frankfurt without any issues. The daily status updates were really reassuring — you always know exactly where your application stands.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ShreveportTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Shreveport &amp; Bossier City Travelers Say About Our Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Shreveport, Bossier City, and Barksdale AFB travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}